module.exports = ".active {\n  background-color: #FFF !important;\n  border: 3px solid #4285F4;\n  color: #4285F4 !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/tabs/tabs.component.scss
// module id = ./src/app/shared/components/tabs/tabs.component.scss
// module chunks = main